export function shouldDestroyEditorOnPageHide(event) {
  try {
    return event?.persisted !== true;
  } catch {
    return true;
  }
}
